export interface IAddress {
  aptOrUnit?: string;
  number?: string;
  zip?: string;
  street?: string;
  state?: string;
  city?: string;
  country?: string;
  street_address?: string;
  lat?: number;
  lng?: number;
  [key: string]: string | number | undefined;
}

export const getAddressObject = (address_components: Array<google.maps.places.AddressComponent>) => {
  interface IShouldBeComponent {
    [key: string]: Array<string>;
  }
  const ShouldBeComponent: IShouldBeComponent = {
    number: ['street_number'],
    zip: ['postal_code'],
    street: ['street_address', 'route'],
    aptOrUnit: ['subpremise'],
    state: [
      'administrative_area_level_1',
      'administrative_area_level_2',
      'administrative_area_level_3',
      'administrative_area_level_4',
      'administrative_area_level_5',
    ],
    city: [
      'locality',
      'sublocality',
      'sublocality_level_1',
      'sublocality_level_2',
      'sublocality_level_3',
      'sublocality_level_4',
      'neighborhood',
    ],
    country: ['country'],
  };

  const address: IAddress = {
    street_address: '',
    aptOrUnit: '',
    number: '',
    zip: '',
    street: '',
    state: '',
    city: '',
    country: '',
  };
  address_components.forEach((component) => {
    for (const shouldBe in ShouldBeComponent) {
      if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
        if (shouldBe === 'country') {
          address[shouldBe] = component.shortText || component.longText || '';
        } else {
          address[shouldBe] = component.longText || component.shortText || '';
        }
      }
    }
  });
  address.street_address = `${address.number} ${address.street}`;
  return address;
};

export const stateAbbreviations: { [key: string]: string } = {
  'alabama': 'AL',
  'alaska': 'AK',
  'arizona': 'AZ',
  'arkansas': 'AR',
  'california': 'CA',
  'colorado': 'CO',
  'connecticut': 'CT',
  'delaware': 'DE',
  'florida': 'FL',
  'georgia': 'GA',
  'hawaii': 'HI',
  'idaho': 'ID',
  'illinois': 'IL',
  'indiana': 'IN',
  'iowa': 'IA',
  'kansas': 'KS',
  'kentucky': 'KY',
  'louisiana': 'LA',
  'maine': 'ME',
  'maryland': 'MD',
  'massachusetts': 'MA',
  'michigan': 'MI',
  'minnesota': 'MN',
  'mississippi': 'MS',
  'missouri': 'MO',
  'montana': 'MT',
  'nebraska': 'NE',
  'nevada': 'NV',
  'new hampshire': 'NH',
  'new jersey': 'NJ',
  'new mexico': 'NM',
  'new york': 'NY',
  'north carolina': 'NC',
  'north dakota': 'ND',
  'ohio': 'OH',
  'oklahoma': 'OK',
  'oregon': 'OR',
  'pennsylvania': 'PA',
  'rhode island': 'RI',
  'south carolina': 'SC',
  'south dakota': 'SD',
  'tennessee': 'TN',
  'texas': 'TX',
  'utah': 'UT',
  'vermont': 'VT',
  'virginia': 'VA',
  'washington': 'WA',
  'west virginia': 'WV',
  'wisconsin': 'WI',
  'wyoming': 'WY',
  'district of columbia': 'DC'
};